var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade-scale"}},[(_vm.visible)?_c('div',{staticClass:"brt-loading"},[_c('div',{staticClass:"wrap"},[_c('i',{staticClass:"iconfont icon-jiazai1"}),_c('span',[_vm._v(_vm._s(_vm.content))])])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }